// import { PsUserLogin } from '@/api/psychology'
import config from '@/config/index'
import md5 from 'js-md5'
const user = {
  state: {
    
  },

  mutations: {
    
  },

  actions: {
    login({ commit }, code) {
      let reqTime = parseInt(new Date().getTime() / 1000)
      let clientSecret=config.client.ClientSeckey
      let clientSignkey = md5(clientSecret + reqTime)
      let params = {
        code,
        reqTime,
        clientSignkey,
        clientId:config.client.client_id
      }
      return new Promise((resolve, reject) => {
        // PsUserLogin(params).then((res) => {
        //   resolve(res)
        // }).catch((e) => {
        //   reject(e)
        // })
      })
    }
  }
}

export default user
